import React from 'react'
import { List } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { CustomText } from 'src/components'
import { Project, VintageItem } from 'src/core/models'
import { getDateFormattedSmall, getFormatedPrice, getVintageAvailableStock } from 'src/core/helpers'
import ProjectDetailsCollapse from '../ProjectDetailsCollapse/ProjectDetailsCollapse'

interface PropsType { project: Project }

const ProjectDetailsVintageItems: React.FC<PropsType> = ({ project }) => {
  const { t } = useTranslation()
  const vintageStock = getVintageAvailableStock(project) || project.get_vintage_items_available_sum_stock
  const vintageSectionLabel = `${t('Projects.Vintages')} (${vintageStock} ${project.unit_of_measurement})`
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList?.find(c => c.id === project.currency_token)?.code
  const { isMobile } = useWindowSize()

  return (
    <ProjectDetailsCollapse label={<CustomText label={vintageSectionLabel} strong />}>
      <List dataSource={project.vintage_items}
        renderItem={(vintageItem: VintageItem) => (
          <List.Item>
            <React.Fragment>
              <CustomText label={`${vintageItem.year}`} strong />
              <div>
                <CustomText label={`${vintageItem?.stock_balance || vintageItem.available_volume_credits}`} strong /> &nbsp;
                <CustomText label={`${project.unit_of_measurement}`} />
              </div>
              <CustomText
                label={`${getFormatedPrice(vintageItem.price, currencyCode)}`}
                className={!isMobile && 'mr-5'}
                strong
              />
              {(project.kind === 'carbon_forward' && vintageItem.delivery_date) && (
                <CustomText
                  label={`${getDateFormattedSmall(vintageItem.delivery_date)}`}
                  strong
                />
              )}
            </React.Fragment>
          </List.Item>
        )}
      />

    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsVintageItems
